export default {
  en: {
    'pages-filing-game-changer-page-components.import-game-changer-modal.title':
      'Upload Amazon transaction data into {appName}',
    'pages-filing-game-changer-page-components.import-game-changer-modal.transactionsReport':
      'Amazon VAT Transactions Report',
    'pages-filing-game-changer-page-components.import-game-changer-modal.fulfillmentsReport':
      'Amazon Fulfillments Report',
    'pages-filing-game-changer-page-components.import-game-changer-modal.import.error':
      'Failed to import data. Please try again.',
    'pages-filing-game-changer-page-components.import-game-changer-modal.import.success':
      '{type} report was imported successfully',
    'pages-filing-game-changer': 'Error validating API credentials',
  },
};
